export default "__VITE_ASSET__CxoumFmI__"